import React, { useState, useEffect, useContext } from 'react';
import { createProject, getCustomers, updateUnits, getUsers, postGeneralData,create_project_assign, ListClient, getAllUsers, updateProject, update_project_assign, } from '../../../Utility/Api';
import { toast } from 'react-toastify';
import { WarehouseContext } from '../../../Utility/UserContext';
import MultiSelect from './MultiSelect';
import MultiSelect2 from './MUltiSelect2';
import CustomerAddModal from '../../Common/CustomerAddModal';
import { formatDate2, shop_id, validateDates } from '../../../Utility/function';
import { getFormattedCurrentDate2 } from "../../../Utility/function";



const ProjectForm = ({ openModal, setOpenModal, unit, closeModal, refreshList, employeeData, managerData }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [isEditMode, setIsEditMode] = useState(!!unit);
  const [users, setUsers] = useState([]);
  const [selectedManager, setSelectedManager] = useState([]);
  const [SelectedTeams, setSelectedTeams] = useState([]);
  const [Client, setClient] = useState([]);
  const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);

  useEffect(() => {
    fetchUsers();
    fetchClient();
  }, []);

  const Filterusers = users.filter(user => user.role_title == "Manager");
  const FilterMembers = users.filter(user => user.role_title == 'Employee')

  const fetchClient = async () => {
    try {
      // const response = await ListClient();
      const response = await getCustomers();
      if (response.data && response.data.data) {
        setClient(response.data.data);
        console.log("project", response.data.data);
      } else {
        toast.error("No units found.");
      }
    } catch (error) {
      console.error("Error fetching units:", error);
      toast.error("Error fetching units");
    }
  };

  const fetchUsers = async (page = 1, text = "") => {
    try {
      const response = await getAllUsers(shopItem?.shop_id);
      if (response.data && response.data.data) {
        console.log(response.data.data);
        setUsers(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      toast.error("Failed to fetch user data");
    }
  };

  const [projectData, setProjectData] = useState({
    title: "",
    description: "",
    start_date: "",
    end_date: "",
    hourly_rate: "",
    notify_at: "",
    total_cost: "",
    total_hours: "",
    status: "0",
    Project_status: "",
    project_type: "1",
    client_id: "",
    estimation_amount: "",
    is_billable: "",
  });

  const [errors, setErrors] = useState({});
  const [isScreenshotEnabled, setIsScreenshotEnabled] = useState(false);
  const [calculate, setCalculate] = useState({
    hourly_rate: "",
    total_hours: "",
  });

  const handleSelectManager = (ID) => {
    setSelectedManager((prevState) => {
      if (prevState.includes(ID)) {
        return prevState.filter((item) => item !== ID);
      } else {
        return [...prevState, ID];
      }
    });
    console.log(ID);
  };

  const handleSelectTeams = (ID) => {
    setSelectedTeams((prevState) => {
      if (prevState.includes(ID)) {
        return prevState.filter((item) => item !== ID);
      } else {
        return [...prevState, ID];
      }
    });
    console.log(ID);
  };

  const [allMember, setAllmember] = useState(false);

  const handleToggleChange = () => {
    setIsScreenshotEnabled((prevState) => !prevState);
    const value = !isScreenshotEnabled ? "true" : "false";
    console.log("Billable enabled value:", value);
    setProjectData({
      ...projectData,
      is_billable: value,
    });
  };

  useEffect(() => {
    if (unit) {
      setProjectData({
        title: unit.title,
        description: unit.description,
        start_date: unit.start_date,
        end_date: unit.end_date,
        hourly_rate: unit.hourly_rate,
        notify_at: unit.notify_at,
        estimation_amount: unit?.estimation_amount,
        total_cost: unit.total_cost,
        total_hours: unit.total_hours,
        project_type: unit.project_type,
        client_id: unit.client_id,
        is_billable: unit.is_billable,
        status: unit.status,
        Project_status: unit.status,
      });
    }
  }, [unit]);

  useEffect(() => {
    if (employeeData) {
      var empdata = employeeData.map((data) => data.emp_id);
      var managerdata = managerData.map((data) => data.emp_id);
      setSelectedTeams(managerdata)
      setSelectedManager(empdata)
      console.log("Emp Data", empdata)
      console.log("Manager Data", managerdata)
    }
  }, [employeeData]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setProjectData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handlePrevious = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleNext = () => {
    if (currentStep == 1 && (!projectData.title || !projectData.description || !projectData.project_type || !projectData.start_date || !projectData.end_date)) {
      toast.error("Required all fields");
      return;
    }
    if (currentStep == 1 && projectData.start_date && projectData.end_date) {
      var error = validateDates(formatDate2(projectData.start_date), formatDate2(projectData.end_date), 'state', 'end');
      if (error) {
        toast.error(error);
        return;
      }
    }
    if (currentStep == 2) {
      if (SelectedTeams.length == 0) {
        toast.error("Please select project manager");
        return;
      }
      if (selectedManager.length == 0) {
        toast.error("Please select team member");
        return;
      }
    }

    setCurrentStep(currentStep + 1);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "hourly_rate" || name === "total_hours") {
      setCalculate((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
    // console.log(calculate);
    setProjectData({
      ...projectData,
      [name]: value,
    });

    const hourlyRate = name === "hourly_rate" ? value : calculate.hourly_rate;
    const totalHours = name === "total_hours" ? value : calculate.total_hours;

    if (hourlyRate && totalHours) {
      const totalCost = parseFloat(hourlyRate) * parseFloat(totalHours);
      setProjectData((prev) => ({
        ...prev,
        total_cost: totalCost,
      }));
    }
  };

  const handleSubmit = async (e) => {
    showLoader();
    e.preventDefault();

    if (!projectData.title) {
      toast.error("Title is required");
      return;
    }

    if (
      !projectData.hourly_rate ||
      !projectData.notify_at ||
      !projectData.total_hours ||
      !projectData.estimation_amount||
      projectData.Project_status === ""
    ) {
      toast.error("Required all fields");
      hideLoader();
      return;
    }

    try {
      if (unit) {
        try {
          var updatePayload = projectData;
          updatePayload.status = projectData.Project_status;
          const response = await updateProject(unit.id, updatePayload);
          hideLoader()
          if (response) {
            const payload =
            {
              "emp_id": selectedManager.join(','),
              "user_role": SelectedTeams.join(','),
              "project_id": response?.data?.data?.id,
              "status": "1"
            }
            await update_project_assign(unit.id, payload);
            toast.success('Project updated successfully');
          } else {
            toast.error('Failed to add project');
          }
        } catch (error) {
          hideLoader()
        }
      } else {
        try {
          var payload = projectData;
          payload.payment_types = amcData.payment_type;
          payload.no_of_year = amcData.no_of_year;
          payload.shop_id = shop_id;
          payload.from_dates = JSON.stringify(amcData.from_dates);
          payload.to_dates = JSON.stringify(amcData.to_dates);

          const response = await createProject(payload); // API call
          hideLoader();

          if (response) {
            // Check API response status

            const payload =
            {
              "emp_id": selectedManager.join(','),
              "user_role": SelectedTeams.join(','),
              "project_id": response?.data?.data?.id,
              "status": "1"
            }
            const project_assign = await create_project_assign(payload);  // API call
            toast.success('Project added successfully');
            try {
              const generalDataPayload = {
                  type: "9",
                  ref_id: payload?.service_id,
                  remarks: "Project Entry",
                  date: getFormattedCurrentDate2(),
                  created_by: payload?.emp_id,
                  shop_id: shopItem?.id || "0",
                  amount: projectData?.total_cost,
                  is_debit: "1",
              };
              await postGeneralData(generalDataPayload);

          } catch (e) {
              console.error("General log failed:", e);
              toast.error("Failed to create general transaction log");
          }
          } else {
            toast.error("Failed to add project");
          }
        } catch (error) {
          hideLoader();
          console.error("Error creating project:", error);
          toast.error("An error occurred while adding the project");
        }
      }
      closeModal();
      hideLoader();
      refreshList();
    } catch (error) {
      console.error('Error saving data:', error);
      hideLoader()
      toast.error('Error saving data');
    }
  };

  const [amcData, setAMCData] = useState({
    payment_type: "",
    no_of_year: "1",
    from_dates: [""], // Store multiple dates as an array
    to_dates: [""],
  });

  const handleChangeAMC = (e) => {
    const { name, value } = e.target;
    setAMCData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDateChange = (index, type, value) => {
    setAMCData((prevState) => {
      const updatedDates = [...prevState[type]];
      updatedDates[index] = value;
      return { ...prevState, [type]: updatedDates };
    });
  };

  const handleNoOfYearsChange = (e) => {
    const value = e.target.value;
    setAMCData((prevState) => ({
      ...prevState,
      no_of_year: value,
      from_dates: new Array(Number(value)).fill(""),
      to_dates: new Array(Number(value)).fill(""),
    }));
  };

  const [showCustomer, setShowCustomer] = useState(false);
  return (
    <>
      <div
        className={`modal fade ${openModal ? "show" : ""}`}
        style={{ display: "block" }}
        tabIndex="-1"
        role="dialog">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" style={{ fontFamily: "poppins" }}>
                {unit ? "Edit Project" : "Add Project"}
              </h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>

            <div className="modal-body" style={{ fontFamily: "poppins" }}>
              <form className="">
                <div className="step-indicator mb-5 mt-3">
                  <span
                    className={`step ${currentStep === 1
                      ? "active"
                      : currentStep > 1
                        ? "completed"
                        : ""
                      }`}
                  >
                    1
                  </span>
                  <span
                    className={`step ${currentStep === 2
                      ? "active"
                      : currentStep > 2
                        ? "completed"
                        : ""
                      }`}
                  >
                    2
                  </span>
                  <span
                    className={`step ${currentStep === 3
                      ? "active"
                      : currentStep > 3
                        ? "completed"
                        : ""
                      }`}
                  >
                    3
                  </span>
                </div>

                {currentStep === 1 && (
                  <>
                    <div className="form-group row">
                      <div
                        className={`form-group col-sm-12 col-lg-6 col-md-6 mb-3`}
                      >
                        <label
                          htmlFor="title"
                          style={{
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#495057",
                          }}
                        >
                          Title :
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter title"
                          id="title"
                          name="title"
                          style={{ fontSize: 14 }}
                          value={projectData.title}
                          onChange={handleInputChange}
                        />
                        {/* {InputFields(t('Title'),'title','text',projectData.title,handleInputChange,t('Enterthetitle'),9,true)} */}
                      </div>
                      <div
                        className={`form-group col-sm-12 col-lg-6 col-md-6 mb-3`}
                      >
                        <label
                          htmlFor="project_type"
                          style={{
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#495057",
                          }}
                        >
                          Projects type:
                        </label>
                        <select
                          className={`form-control `}
                          id="project_type"
                          name="project_type"
                          style={{ fontSize: 14 }}
                          value={projectData.project_type}
                          onChange={handleInputChange}
                        >
                          <option disabled value="" selected>
                            Project Type
                          </option>
                          <option value="1">Fixed Cost</option>
                          <option value="2">Retainer</option>
                          <option value="3">Time & Material</option>
                          {/* <option value="4">AMC Period</option> */}
                        </select>
                      </div>
                    </div>
                    <div className={`form-group mb-3`}>
                      <label
                        htmlFor="Description"
                        style={{
                          fontSize: 15,
                          fontWeight: "bold",
                          color: "#495057",
                        }}
                      >
                        Description :
                      </label>
                      <textarea
                        className="form-control"
                        placeholder="Enter Description"
                        id="description"
                        name="description"
                        value={projectData.description}
                        onChange={handleInputChange}
                        style={{ height: "100px", fontSize: 14 }}
                      />
                    </div>
                    <div className={`form-group row mb-3`}>
                      <div className="form-group col-md-6">
                        <label
                          htmlFor="start_date"
                          style={{
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#495057",
                          }}
                        >
                          StartDate :
                        </label>
                        <input
                          type="date"
                          className={`form-control`}
                          id="start_date"
                          name="start_date"
                          style={{ fontSize: 14 }}
                          value={projectData.start_date}
                          max={projectData.end_date}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label
                          htmlFor="end_date"
                          style={{
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#495057",
                          }}
                        >
                          EndDate :
                        </label>
                        <input
                          type="date"
                          className={`form-control`}
                          id="end_date"
                          name="end_date"
                          style={{ fontSize: 14 }}
                          value={projectData.end_date}
                          min={projectData.start_date}
                          onChange={handleInputChange}
                        />
                        {/* {InputFields(t('EndDate'),'end_date','date',projectData.end_date,handleInputChange,t('Enter_date'),9,true)} */}
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <div
                        className={`form-group col-md-6 align-items-center d-flex align-items-center`}
                      >
                        <label
                          htmlFor="screenshotToggle"
                          className="col-form-label mr-2"
                          style={{
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#495057",
                          }}
                        >
                          isbillable :
                        </label>
                        <label className="switch mb-0">
                          <input
                            type="checkbox"
                            checked={isScreenshotEnabled}
                            onChange={handleToggleChange}
                          />
                          <span className="slider round"></span>
                        </label>
                      </div>
                      <div className={`form-group col-md-6 `}>
                        <label
                          htmlFor="client_id"
                          style={{
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#495057",
                          }}
                        >
                          Customer Name:
                        </label>
                        <div className="d-flex">
                          <select
                            className="form-control"
                            id="client_id"
                            name="client_id"
                            value={projectData.client_id}
                            onChange={handleInputChange}
                            style={{ fontSize: 14 }}
                          >
                            <option disabled selected value="">
                              Select Customer
                            </option>

                            {Client.filter(item => item.status != 1).map((client) => (
                              <option
                                value={client.customer_id}
                                key={client.customer_id}
                              >
                                {client.name}
                              </option>
                            ))}
                          </select>
                          <div
                            onClick={() => setShowCustomer(true)}
                            className="mx-2 btn btn-secondary bg-gray-500 text-white px-2 py-1 rounded-lg  font-semibold shadow-md hover:bg-gray-600 transition align-content-center"
                            style={{ fontSize: "12px" }}
                          >
                            Add
                          </div>
                        </div>
                      </div>
                      {/* {SelectOptions(`${t('Client')} ${t('Name')}`,'client_id',projectData.client_id,handleInputChange,`${t('Select')} ${t('Client')}`,clients,4)} */}
                    </div>
                  </>
                )}

                {currentStep === 2 && (
                  <>
                    <div className="d-flex flex-column form-group w-100 my-3 pb-3 mb-5">
                      <label
                        htmlFor="sidebar-checkboxes"
                        className={`col-form-label`}
                        style={{
                          fontSize: 15,
                          fontWeight: "bold",
                          color: "#495057",
                        }}
                      >
                        Select Manager:
                      </label>
                      <MultiSelect2
                        title={
                          SelectedTeams.length > 0
                            ? Filterusers.filter((employee) =>
                              SelectedTeams.includes(employee.user_Id)
                            )
                              .map((employee) => employee.full_name)
                              .join(", ")
                            : "Select Manager Team"
                        }
                        options={Filterusers}
                        selectedValues={SelectedTeams}
                        onChange={handleSelectTeams}
                        search={true}
                      />
                    </div>

                    <div className="d-flex flex-column form-group w-100 mt-3 mb-5">
                      <label
                        htmlFor="emp_id"
                        style={{
                          fontSize: 15,
                          fontWeight: "bold",
                          color: "#495057",
                        }}
                        className={`col-form-label`}
                      >
                        TeamMember :
                      </label>
                      <MultiSelect
                        title={
                          selectedManager.length > 0
                            ? users
                              .filter((employee) =>
                                selectedManager.includes(employee.user_Id)
                              )
                              .map((employee) => employee.full_name)
                              .join(", ")
                            : "Select Team Member"
                        }
                        options={FilterMembers}
                        selectedValues={selectedManager}
                        onChange={handleSelectManager}
                        search={true}
                      />
                    </div>
                  </>
                )}

                {false && (
                  <>
                    <div className={`form-group row`}>
                      <div className={`form-group col-md-6`}>
                        <label
                          htmlFor="client_id"
                          style={{
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#495057",
                          }}
                        >
                          Client Name:
                        </label>
                        <select
                          className="form-control"
                          id="client_id"
                          name="client_id"
                          value={projectData.client_id}
                          onChange={handleInputChange}
                          style={{ fontSize: 14 }}
                        >
                          <option disabled selected value="">
                            Select Client
                          </option>
                          {/* {clients.map((client) => (
                      <option value={client.id} key={client.id}>
                        {client.first_name} {client.last_name}
                      </option>
                    ))} */}
                        </select>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div
                        className={`form-group col-md-6 align-items-center d-flex align-items-center`}
                      >
                        <label
                          htmlFor="screenshotToggle"
                          className="col-form-label mr-2"
                          style={{ fontSize: 14 }}
                        >
                          Is Billable:
                        </label>
                        <label className="switch mb-0">
                          <input
                            type="checkbox"
                            checked={isScreenshotEnabled}
                            onChange={handleToggleChange}
                          />
                          <span className="slider round"></span>
                        </label>
                      </div>
                    </div>
                    <div className={`form-group row`}>
                      <div className="form-group col-md-6">
                        <label htmlFor="start_date" style={{ fontSize: 14 }}>
                          Start Date:
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          id="start_date"
                          name="start_date"
                          style={{ fontSize: 14 }}
                          value={projectData.start_date}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label htmlFor="end_date" style={{ fontSize: 14 }}>
                          End Date:
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          id="end_date"
                          name="end_date"
                          style={{ fontSize: 14 }}
                          value={projectData.end_date}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </>
                )}

                {currentStep === 3 && (
                  <>
                    <div className="form-row row mb-3">
                      <div className={`form-group col-md-6`}>
                        <label
                          htmlFor="hourly_rate"
                          style={{
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#495057",
                          }}
                        >
                          Hour Rate:
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="hourly_rate"
                          name="hourly_rate"
                          placeholder="Enter HourRate"
                          style={{ fontSize: 14 }}
                          value={projectData.hourly_rate}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className={`form-group col-md-6`}>
                        <label
                          htmlFor="notify_at"
                          style={{
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#495057",
                          }}
                        >
                          Notify At:
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="notify_at"
                          name="notify_at"
                          placeholder="Enter Notify At"
                          style={{ fontSize: 14 }}
                          value={projectData.notify_at}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="form-row row mb-3">
                      <div className={`form-group col-md-6`}>
                        <label
                          htmlFor="total_hours"
                          style={{
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#495057",
                          }}
                        >
                          Total Hours :
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="total_hours"
                          placeholder="Enter TotalHours"
                          name="total_hours"
                          style={{ fontSize: 14 }}
                          value={projectData.total_hours}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className={`form-group col-md-6 `}>
                        <label
                          htmlFor="total_cost"
                          style={{
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#495057",
                          }}
                        >
                          Total Cost :
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="total_cost"
                          placeholder="Enter TotalCost"
                          name="total_cost"
                          style={{ fontSize: 14 }}
                          value={projectData.total_cost}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className={`form-group mb-3 row`}>
                      <div className={`form-group col-md-6`}>
                        <label
                          htmlFor="Project_status"
                          style={{
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#495057",
                          }}
                        >
                          Project Status:
                        </label>
                        <select
                          className="form-control"
                          id="Project_status"
                          name="Project_status"
                          value={projectData.Project_status}
                          style={{ fontSize: 14 }}
                          onChange={handleInputChange}
                          required
                        >
                          <option disabled selected value="">
                            Select Status
                          </option>
                          <option value="0" className="ms-3">
                            In Progress
                          </option>
                          <option value="1" className="ms-3">
                            Cancelled
                          </option>
                          <option value="2" className="ms-3">
                            Completed
                          </option>
                          <option value="3" className="ms-3">
                            yet to start
                          </option>
                        </select>
                      </div>
                      <div className={`form-group col-md-6`}>
                        <label
                          htmlFor="total_hours"
                          style={{
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#495057",
                          }}
                        >
                          Estimation Amount :
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="estimation_amount"
                          placeholder="Enter Estimation Amount"
                          name="estimation_amount"
                          style={{ fontSize: 14 }}
                          value={projectData.estimation_amount}
                          onChange={handleInputChange}
                          required
                          disabled={isEditMode}

                        />
                      </div>
                    </div>
                  </>
                )}

                {currentStep === 4 && (
                  <>
                    <div className="form-group row">
                      <div
                        className={`form-group col-sm-12 col-lg-6 col-md-6 mb-3`}
                      >
                        <label
                          htmlFor="payment_type"
                          style={{
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#495057",
                          }}
                        >
                          Payment type:
                        </label>
                        <select
                          className={`form-control`}
                          id="payment_type"
                          name="payment_type"
                          style={{ fontSize: 14 }}
                          value={amcData.payment_type}
                          onChange={handleChangeAMC}
                        >
                          <option disabled value="">
                            Payment Type
                          </option>
                          <option value="1">Single Payment</option>
                          <option value="2">Yearly Payment</option>
                        </select>
                      </div>

                      {/* Show No Of Year only if "Yearly Payment" is selected */}
                      {amcData.payment_type === "2" && (
                        <div
                          className={`form-group col-sm-12 col-lg-6 col-md-6 mb-3`}
                        >
                          <label
                            htmlFor="no_of_year"
                            style={{
                              fontSize: 15,
                              fontWeight: "bold",
                              color: "#495057",
                            }}
                          >
                            No Of Year:
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter No Of Year"
                            id="no_of_year"
                            name="no_of_year"
                            style={{ fontSize: 14 }}
                            value={amcData.no_of_year}
                            onChange={handleNoOfYearsChange}
                          />
                        </div>
                      )}
                    </div>

                    <div className={`form-group row mb-3`}>
                      {/* If Single Payment, show only one set of from and to date */}
                      {amcData.payment_type === "1" && (
                        <>
                          <div className="form-group col-md-6">
                            <label
                              htmlFor="from_date"
                              style={{
                                fontSize: 15,
                                fontWeight: "bold",
                                color: "#495057",
                              }}
                            >
                              Start Date:
                            </label>
                            <input
                              type="date"
                              className={`form-control`}
                              id="from_date"
                              name="from_date"
                              style={{ fontSize: 14 }}
                              value={amcData.from_dates[0]}
                              onChange={(e) =>
                                handleDateChange(
                                  0,
                                  "from_dates",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                          <div className="form-group col-md-6 mb-3">
                            <label
                              htmlFor="to_date"
                              style={{
                                fontSize: 15,
                                fontWeight: "bold",
                                color: "#495057",
                              }}
                            >
                              End Date:
                            </label>
                            <input
                              type="date"
                              className={`form-control`}
                              id="to_date"
                              name="to_date"
                              style={{ fontSize: 14 }}
                              value={amcData.to_dates[0]}
                              onChange={(e) =>
                                handleDateChange(0, "to_dates", e.target.value)
                              }
                            />
                          </div>
                        </>
                      )}

                      {/* If Yearly Payment, dynamically generate from & to date fields */}
                      {amcData.payment_type === "2" &&
                        amcData.from_dates.map((_, index) => (
                          <div key={index} className="form-group row w-100">
                            <div className="form-group col-md-6">
                              <label
                                htmlFor={`from_date_${index}`}
                                style={{
                                  fontSize: 15,
                                  fontWeight: "bold",
                                  color: "#495057",
                                }}
                              >
                                Start Date (Year {index + 1}):
                              </label>
                              <input
                                type="date"
                                className="form-control"
                                id={`from_date_${index}`}
                                name={`from_date_${index}`}
                                style={{ fontSize: 14 }}
                                value={amcData.from_dates[index]}
                                onChange={(e) =>
                                  handleDateChange(
                                    index,
                                    "from_dates",
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                            <div className="form-group col-md-6 mb-3">
                              <label
                                htmlFor={`to_date_${index}`}
                                style={{
                                  fontSize: 15,
                                  fontWeight: "bold",
                                  color: "#495057",
                                }}
                              >
                                End Date (Year {index + 1}):
                              </label>
                              <input
                                type="date"
                                className="form-control"
                                id={`to_date_${index}`}
                                name={`to_date_${index}`}
                                style={{ fontSize: 14 }}
                                value={amcData.to_dates[index]}
                                onChange={(e) =>
                                  handleDateChange(
                                    index,
                                    "to_dates",
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          </div>
                        ))}
                    </div>
                  </>
                )}
              </form>
            </div>

            <div className="modal-footer">
              {currentStep == 1 && (
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setOpenModal(false)}
                >
                  close
                </button>
              )}
              {currentStep > 1 && (
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handlePrevious}
                >
                  Previous
                </button>
              )}
              {currentStep < 3 && (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={handleNext}
                >
                  Continue
                </button>
              )}
              {currentStep === 3 && projectData.project_type == "4" && (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={handleNext}
                >
                  Continue
                </button>
              )}
              {currentStep === 3 && projectData.project_type != "4" && (
                <button type="button" className="btn btn-success" onClick={handleSubmit}>
                  Submit
                </button>
              )}
              {currentStep === 4 && projectData.project_type == "4" && (
                <button type="button" className="btn btn-success" onClick={handleSubmit}>
                  Submit
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <CustomerAddModal
        showCustomer={showCustomer}
        setShowCustomer={setShowCustomer}
        onReqCustomer={fetchClient}
      />
    </>
  );
};

export default ProjectForm;
